import { __exports as r } from "./index203.js";
Object.defineProperty(r, "__esModule", { value: !0 });
r.camelCase = void 0;
var n = /^--[a-zA-Z0-9_-]+$/, c = /-([a-z])/g, s = /^[^-]+$/, u = /^-(webkit|moz|ms|o|khtml)-/, a = /^-(ms)-/, i = function(e) {
  return !e || s.test(e) || n.test(e);
}, l = function(e, t) {
  return t.toUpperCase();
}, o = function(e, t) {
  return "".concat(t, "-");
}, m = function(e, t) {
  return t === void 0 && (t = {}), i(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(a, o) : e = e.replace(u, o), e.replace(c, l));
};
r.camelCase = m;
export {
  r as default
};
